/* eslint-disable no-param-reassign */
import produce from 'immer';
import { MESSAGING_SETTINGS } from 'src/constants';
import {
  GET_MESSAGE_SEND_HOURS,
  GET_MESSAGE_SEND_HOURS_SUCCESS,
  GET_MESSAGE_SEND_HOURS_ERROR,
  UPDATE_MESSAGE_SEND_HOURS,
  UPDATE_MESSAGE_SEND_HOURS_SUCCESS,
  UPDATE_MESSAGE_SEND_HOURS_ERROR,
  GET_KEYWORDS_LIST,
  GET_KEYWORDS_LIST_SUCCESS,
  GET_KEYWORDS_LIST_ERROR,
  GET_KEYWORD,
  GET_KEYWORD_SUCCESS,
  GET_KEYWORD_ERROR,
  CREATE_KEYWORD,
  CREATE_KEYWORD_SUCCESS,
  CREATE_KEYWORD_ERROR,
  UPDATE_KEYWORD,
  UPDATE_KEYWORD_SUCCESS,
  UPDATE_KEYWORD_ERROR,
  CHANGE_KEYWORD_STATUS,
  CHANGE_KEYWORD_STATUS_SUCCESS,
  CHANGE_KEYWORD_STATUS_ERROR,
  DELETE_KEYWORD,
  DELETE_KEYWORD_SUCCESS,
  DELETE_KEYWORD_ERROR,
  CLEAR_KEYWORD_WAS_DELETED,
  CLEAR_KEYWORDS_LIST,
  CLEAR_KEYWORD_DETAILS,
  SET_CURRENT_NAVIGATION_TAB,
  SET_KEYWORD_DETAILS_VIEW_TAB,
  SET_KEYWORDS_QUERY,
  SET_BACK_TO_KEYWORDS_LIST,
  SET_SELECTED_KEYWORDS,
  GET_FOLLOW_UP_MESSAGES,
  GET_FOLLOW_UP_MESSAGES_SUCCESS,
  GET_FOLLOW_UP_MESSAGES_ERROR,
  REPLACE_SYSTEM_GEN_MESSAGE,
  REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
  REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
  SET_VALUES_FORM_SEND_TEXT,
  GET_AUTO_READ_KEYWORD_SETTING,
  GET_AUTO_READ_KEYWORD_SETTING_SUCCESS,
  GET_AUTO_READ_KEYWORD_SETTING_ERROR,
  UPDATE_AUTO_READ_KEYWORD_SETTING,
  UPDATE_AUTO_READ_KEYWORD_SETTING_SUCCESS,
  UPDATE_AUTO_READ_KEYWORD_SETTING_ERROR,
} from 'src/actions/messagingSettingsActions';

const initialCurrentNavigationTab = 'messageSendHours';
const initialKeywordDetailsCurrentNavigationTab = 'details';
const backToKeywordsList = {
  keywords: [],
  keywordsQuery: {},
  active: false,
  comeBack: false,
};
const followUpMessages = {
  followUpMessageList: [],
  loading: false,
};
const formSendText = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const initialState = {
  currentNavigationTab: initialCurrentNavigationTab,
  keywordsList: {
    keywords: [],
    loading: false,
  },
  selectedKeywords: [],
  keywordsQuery: {
    status: MESSAGING_SETTINGS.MESSAGING_SETTINGS_KEYWORDS_STATUS.ACTIVE,
    sort: [['name', 'asc']],
    page: 1,
    pageSize: 50,
    count: 0,
  },
  messageSendHours: {},
  keywordDetails: {
    currentNavigationTab: initialKeywordDetailsCurrentNavigationTab,
    keyword: {},
    keywordWasDeleted: false,
    loading: false,
  },
  loading: false,
  backToKeywordsList,
  followUpMessages,
  formSendText,
  autoReadKeywordReplies: false,
  autoReadKeywordRepliesLoading: false,
};

const messagingSettingsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MESSAGE_SEND_HOURS:
    case UPDATE_MESSAGE_SEND_HOURS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_MESSAGE_SEND_HOURS_SUCCESS: {
      return produce(state, (draft) => {
        draft.messageSendHours = payload || {};
        draft.loading = false;
      });
    }

    case UPDATE_MESSAGE_SEND_HOURS_SUCCESS: {
      return produce(state, (draft) => {
        // draft.messageSendHours = payload;
        draft.loading = false;
      });
    }

    case GET_MESSAGE_SEND_HOURS_ERROR:
    case UPDATE_MESSAGE_SEND_HOURS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_KEYWORDS_LIST: {
      return produce(state, (draft) => {
        draft.keywordsList.loading = true;
      });
    }

    case GET_KEYWORDS_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.keywordsList.keywords = payload?.data || [];
        draft.keywordsQuery.count = payload?.count || 0;
        draft.keywordsList.loading = false;
      });
    }

    case GET_KEYWORDS_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.keywordsList.loading = false;
        draft.keywordsQuery.count = 0;
      });
    }

    case GET_KEYWORD:
    case CREATE_KEYWORD:
    case UPDATE_KEYWORD:
    case CHANGE_KEYWORD_STATUS: {
      return produce(state, (draft) => {
        draft.keywordDetails.loading = true;
      });
    }

    case GET_KEYWORD_SUCCESS: {
      return produce(state, (draft) => {
        draft.keywordDetails.keyword = payload || {};
        draft.keywordDetails.loading = false;
      });
    }

    case GET_KEYWORD_ERROR:
    case CREATE_KEYWORD_SUCCESS:
    case CREATE_KEYWORD_ERROR:
    case UPDATE_KEYWORD_SUCCESS:
    case UPDATE_KEYWORD_ERROR:
    case CHANGE_KEYWORD_STATUS_SUCCESS:
    case CHANGE_KEYWORD_STATUS_ERROR: {
      return produce(state, (draft) => {
        draft.keywordDetails.loading = false;
      });
    }

    case DELETE_KEYWORD: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.keywordDetails.loading = true;
      });
    }

    case DELETE_KEYWORD_SUCCESS: {
      const { cancelRedirectToKeywordsList } = payload;
      return produce(state, (draft) => {
        draft.keywordDetails.loading = false;
        draft.loading = false;
        if (!cancelRedirectToKeywordsList) {
          draft.keywordDetails.keywordWasDeleted = true;
        }
      });
    }

    case DELETE_KEYWORD_ERROR: {
      return produce(state, (draft) => {
        draft.keywordDetails.loading = false;
        draft.loading = false;
      });
    }

    case CLEAR_KEYWORDS_LIST: {
      return produce(state, (draft) => {
        draft.keywordsList = initialState.keywordsList;
      });
    }

    case CLEAR_KEYWORD_DETAILS: {
      return produce(state, (draft) => {
        draft.keywordDetails.keyword = {};
      });
    }

    case CLEAR_KEYWORD_WAS_DELETED: {
      return produce(state, (draft) => {
        draft.keywordDetails.keywordWasDeleted = false;
      });
    }

    case SET_CURRENT_NAVIGATION_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialCurrentNavigationTab;
      });
    }

    case SET_KEYWORD_DETAILS_VIEW_TAB: {
      return produce(state, (draft) => {
        draft.keywordDetails.currentNavigationTab = payload || initialKeywordDetailsCurrentNavigationTab;
      });
    }

    case SET_KEYWORDS_QUERY: {
      return produce(state, (draft) => {
        draft.keywordsQuery = payload ? {
          ...state.keywordsQuery,
          ...payload
        } : initialState.keywordsQuery;
      });
    }

    case SET_BACK_TO_KEYWORDS_LIST: {
      return produce(state, (draft) => {
        draft.backToKeywordsList = payload ? {
          ...state.backToKeywordsList,
          ...payload,
        } : backToKeywordsList;
      });
    }

    case SET_SELECTED_KEYWORDS: {
      return produce(state, (draft) => {
        draft.selectedKeywords = payload || [];
      });
    }

    case GET_FOLLOW_UP_MESSAGES: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = true;
      });
    }

    case GET_FOLLOW_UP_MESSAGES_SUCCESS:
    case GET_FOLLOW_UP_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = false;
        draft.followUpMessages.followUpMessageList = payload ? [
          ...state.followUpMessages.followUpMessageList,
          ...payload,
        ] : followUpMessages.followUpMessageList;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE: {
      return produce(state, (draft) => {
        draft.formSendText.loading = true;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS:
    case REPLACE_SYSTEM_GEN_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.formSendText.loading = false;
        draft.formSendText.systemGenMessageReplaced = payload || false;
      });
    }

    case SET_VALUES_FORM_SEND_TEXT: {
      return produce(state, (draft) => {
        draft.formSendText = payload ? {
          ...state.formSendText,
          ...payload,
        } : formSendText;
      });
    }

    case GET_AUTO_READ_KEYWORD_SETTING:
    case UPDATE_AUTO_READ_KEYWORD_SETTING: {
      return produce(state, (draft) => {
        draft.autoReadKeywordRepliesLoading = true;
      });
    }

    case GET_AUTO_READ_KEYWORD_SETTING_SUCCESS:
    case UPDATE_AUTO_READ_KEYWORD_SETTING_SUCCESS: {
      return produce(state, (draft) => {
        draft.autoReadKeywordReplies = payload;
        draft.autoReadKeywordRepliesLoading = false;
      });
    }

    case GET_AUTO_READ_KEYWORD_SETTING_ERROR:
    case UPDATE_AUTO_READ_KEYWORD_SETTING_ERROR: {
      return produce(state, (draft) => {
        draft.autoReadKeywordRepliesLoading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default messagingSettingsReducer;
